<section>
    <h2>{{'mantenimientoIncidencias.incidencia.titulo' | translate}}</h2>
    <form [formGroup]="incidenciaForm" [ngClass]="{'show-error':showError}">
        <div class="info-title">{{'global.infoRequired' | translate}}</div>
        <div class="entry-1">
            <label>{{'mantenimientoIncidencias.incidencia.descripcion' | translate}} *</label>
            <textarea formControlName="descripcion"></textarea>
        </div>
        <div class="entry-3-modal">
            <label>{{'mantenimientoIncidencias.incidencia.tipoIncidencia.titulo' | translate}} *</label>
            <app-filterable-list [itemsList]="tiposIncidencia" [selectedItem]="incidenciaForm.get('incidenciaTipo')" [disabled]="disabledTiposInc" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-3-modal">
            <label>{{'mantenimientoIncidencias.incidencia.unidadesAfectadas.titulo' | translate}}</label>
            <app-filterable-list [itemsList]="etqAfectadas" [selectedItem]="incidenciaForm.get('numEtiquetas')" [disabled]="disabledEtqAfectadas" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-3-modal" *ngIf="incidenciaForm.get('numEtiquetas').value && (incidenciaForm.get('numEtiquetas').value.value === 2 || incidenciaForm.get('numEtiquetas').value.value === 3)">
            <ng-container *ngIf="incidenciaForm.get('numEtiquetas').value && incidenciaForm.get('numEtiquetas').value.value === 2">
                <label>{{'mantenimientoIncidencias.incidencia.desde' | translate}} *</label>
                <input type="text" formControlName="numEtiquetasDesde">
            </ng-container>
            <ng-container *ngIf="incidenciaForm.get('numEtiquetas').value && incidenciaForm.get('numEtiquetas').value.value === 3">
                <label>{{'mantenimientoIncidencias.incidencia.numeroEtq' | translate}} *</label>
                <input type="number" formControlName="numEtiquetasN">
            </ng-container>
        </div>
        <div class="entry-3-modal" *ngIf="incidenciaForm.get('numEtiquetas').value && incidenciaForm.get('numEtiquetas').value.value === 2">
            <label>{{'mantenimientoIncidencias.incidencia.hasta' | translate}} *</label>
            <input type="text" formControlName="numEtiquetasHasta">
        </div>
        <div class="entry-3-modal alignment-start">
          <input type="checkbox" id="etiquetasGuardadas" formControlName="etiquetasGuardadas">
          <label for="etiquetasGuardadas">{{'mantenimientoIncidencias.incidencia.guardadas' | translate}}</label>
        </div>
        <div class="entry-3-modal">
            <label>{{'mantenimientoIncidencias.incidencia.persona' | translate}} *</label>
            <input type="text" formControlName="nombrePersonaAlta">
        </div>
        <div class="entry-3-modal">
            <label>{{'mantenimientoIncidencias.incidencia.email' | translate}} *</label>
            <input type="email" formControlName="emailPersonaAlta">
        </div>
        <ng-container *ngIf="incidenciaGestionada || rolePermission">
            <div class="entry-3-modal">
                <label>{{'mantenimientoIncidencias.incidencia.unidadesDevolver' | translate}} *</label>
                <input type="number" formControlName="numEtiquetasEfectivas">
            </div>
            <div class="entry-1">
                <label>{{'mantenimientoIncidencias.incidencia.comentarios' | translate}} *</label>
                <textarea formControlName="comentariosSoporte"></textarea>
            </div>
            <div class="entry-1" *ngIf="incidenciaGestionada">
                <label>{{'mantenimientoIncidencias.incidencia.gestionada' | translate}}
                    {{incidenciaForm.get('fechaGestion').value}}.</label>
            </div>
        </ng-container>
    </form>
</section>
<footer class="button-bar-right into-child">
    <button class="secondary" (click)="toClose()">{{(incidenciaGestionada && !rolePermission ? 'global.cerrar' :
        'global.cancelar') | translate}}</button>
    <button *ngIf="!(incidenciaGestionada && !rolePermission)" (click)="save()">{{incidenciaId ? ('global.actualizar' |
        translate) : ('global.insertar' | translate)}}</button>
</footer>
